import React, { useCallback, useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useSelector, useDispatch } from "react-redux";
import { priceActions } from "../../../redux/actions/guides";
import { SimpleModal, MyInput, DialogModal } from "../../../components";
import * as Yup from "yup";
import DeleteIcon from '@material-ui/icons/Delete';
import { Button } from "@material-ui/core";
import { useStateIfMounted } from "use-state-if-mounted";

const defaultValues = {
  namePrice: "",
  description: "",
};

const validationSchema = Yup.object().shape({
  namePrice: Yup.string().max(255, "Превышено максимальное кол-во символов(255)").required("Обязательное для заполнения поле"),
  description: Yup.string().max(255, "Превышено максимальное кол-во символов(255)").nullable(),
});

export const ModalPrice = ({ modalShow, onClose, isAddMode, setIsAddMode, id, refresh = () => {} }) => {
  const dispatch = useDispatch();
  const { item, loadingItem, fetchedItem, deleted, error } = useSelector((state) => state.guides.prices);

  const [deleteDialog, setDeleteDialog] = useStateIfMounted(false);

  const {
    control,
    handleSubmit,
    formState: { errors },
    clearErrors,
    setValue,
    reset,
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: defaultValues,
  });

  const onSubmit = (data) => {
    return isAddMode ? dispatch(priceActions.create(data)) : dispatch(priceActions.update(item.id, data));
  };

  useEffect(() => {
    if (!modalShow || isAddMode) return;

    dispatch(priceActions.getById(id));

    return () => dispatch({ type: "RESET_ITEM_PRICES" });
  }, [modalShow]);

  useEffect(() => {
    if (!fetchedItem || isAddMode) return;

    Object.keys(defaultValues).forEach((field) => setValue(field, item[field]));
  }, [item]);

  const handleDeleteClick = useCallback((id) => {
    dispatch(priceActions.delete(id));
    setDeleteDialog(false);
  }, [dispatch, setDeleteDialog]);

  useEffect(() => {
    if (deleted && modalShow) {
      setDeleteDialog(false);
      closeModalFunc();
      onClose();
      refresh();
      console.log('Тип цены успешно удален');
    }
  }, [deleted]);

  useEffect(() => {
    if (!error && isAddMode && fetchedItem) {
      setIsAddMode(false);
    }
  }, [error, loadingItem, fetchedItem]);

  const closeModalFunc = () => {
    clearErrors();
    reset(defaultValues);
  };

  return (
    <div>
      <SimpleModal
        modalTitle={isAddMode ? "Новый тип цен" : "Редактирование"}
        winPermissionName="Общие"
        modalShow={modalShow}
        modalSize="sm"
        fullScreen={false}
        loading={loadingItem}
        isAddMode={isAddMode}
        status={!isAddMode}
        operations={item}
        onSubmit={handleSubmit(onSubmit)}
        onClose={() => {
          onClose();
          closeModalFunc();
        }}
      >
        <form noValidate>
          <MyInput name="namePrice" control={control} label="Наименование" required errors={errors?.namePrice} />
          <MyInput name="description" control={control} label="Комментарий" multiline rows={3} errors={errors?.description}/>
          <div>
            <Button
              disabled={item?.id === null || item?.id === undefined}
              aria-describedby={id}
              size="small"
              color="primary"
              onClick={() => setDeleteDialog(true)}
              startIcon={<DeleteIcon />}
            >
              Удалить
            </Button>
          </div>
        </form>
      </SimpleModal>
      <DialogModal
        open={deleteDialog}
        onConfirmDialogClose={() => setDeleteDialog(false)}
        onYesClick={() => handleDeleteClick(item?.id)}
        text={`Вы действительно хотите удалить тип цены - ${item?.namePrice}? Это действие невозможно отменить.`}
      />
    </div>
  );
};